import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

window.Swiper = Swiper;
window.SwiperNavigation = Navigation;